import React, { useState, useEffect, useMemo } from "react";
import { Card } from "../../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import UploadService from "../../../../services/FileUploadService";
import BootstrapTable from "react-bootstrap-table-next";
import axios from "axios";

export function CustomersFileUpload() {
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [currentFile, setCurrentFile] = useState(undefined);
  const [progress, setProgress] = useState(0);
  const [previewFile, setPreviewFile] = useState(undefined);
  const [previewColumns, setPreviewColumns] = useState({});
  const [message, setMessage] = useState("");
  const [accountingSoftwares, setAccountingSoftwares] = useState(null);
  const [accountingSoftwareType, setAccountingSoftwareType] = useState(null);
  const [fields, setFields] = useState({
    customerCode: "",
    customerTaxId: "",
    customerName: "",
    columnDelimiter: "",
    customerGrace: "",
    template: false,
    templateName: "",
  });

  function previewExcelDetails(skipLines) {
    if (skipLines == "") skipLines = 0;

    let formData = new FormData();
    formData.append("files", selectedFiles[0]);
    formData.append("accounting_software_type", accountingSoftwareType);
    formData.append("skipLines", skipLines);

    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}file-preview`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function(response) {
        if (response.data.response.length > 0) {
          let objectKeys = Object.keys(response.data.response[0]);

          let colsArray = new Array();

          for (let index = 0; index < objectKeys.length; index++) {
            colsArray.push({
              dataField: objectKeys[index],
              text: objectKeys[index],
            });
          }

          setPreviewColumns(colsArray);
          setPreviewFile(response.data.response);
          //     setPreviewFile
        } else {
          setPreviewColumns([]);
          setPreviewFile([]);
        }
      });
  }

  useEffect(() => {
    selectedFiles && previewExcelDetails(0);
  }, [selectedFiles]);

  const selectFile = (event) => {
    setSelectedFiles(event.target.files);
  };
  const accountingSoftwareChanged = (event) => {
    setAccountingSoftwareType(event.target.value);
    loadAccountingSoftwareFields(event.target.value);
  };

  function loadIsTemplate() {
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}customer-file-mapping-template`
      )
      .then((response) => response.data)
      .then((d) => {
        if (d && d[0]) {
          setFields({
            ...fields,
            ...d[0].template,
            templateName: d[0].name,
            template: false,
          });
        } else {
          if (accountingSoftwares) {
            setAccountingSoftwareType(accountingSoftwares[0].type);
            loadAccountingSoftwareFields(accountingSoftwares[0].type);
          } else {
            axios
              .get(`${process.env.REACT_APP_API_BASE_URL}accounting-software`)
              .then((response) => response.data)
              .then((res) => {
                setAccountingSoftwares(res);
                setAccountingSoftwareType(res[0].type);
                loadAccountingSoftwareFields(res[0].type);
              });
          }
        }
      });
  }

  function loadAccountingSoftwareFields(accountingSoftwareType) {
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}accounting-software-customer-fields/${accountingSoftwareType}`
      )
      .then((response) => response.data)
      .then((f) => {
        setFields({ ...fields, ...f });
      });
  }

  function onMappingFormChange(key, value) {
    setFields({ ...fields, [key]: value });
  }
  const refreshPreview = (skipLines) => {
    previewExcelDetails(skipLines);
  };
  const upload = () => {
    let currentFile = selectedFiles[0];
    setProgress(0);
    setCurrentFile(currentFile);

    UploadService.upload(
      currentFile,
      "customer-upload",
      accountingSoftwareType,
      fields,

      (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      }
    )
      .then((response) => {
        setMessage("file Uploaded, data will be updated soon...");
        setCurrentFile(undefined);
      })
      .then((files) => {})
      .catch(() => {
        setProgress(0);
        setMessage("Could not upload the file!");
        setCurrentFile(undefined);
      });

    setSelectedFiles(undefined);
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}accounting-software`)
      .then((response) => response.data)
      .then(setAccountingSoftwares);
  }, []); // Or [] if effect doesn't need props or state

  useEffect(() => {
    loadIsTemplate();
  }, []);

  if (accountingSoftwares) {
    // if (!accountingSoftwareType) {
    //   setAccountingSoftwareType(accountingSoftwares[0].type);
    //   loadAccountingSoftwareFields(accountingSoftwares[0].type);
    // }

    return (
      <Card>
        <div className="container">
          {/* {currentFile && (
            <div className="progress">
              <div
                className="progress-bar progress-bar-info progress-bar-striped"
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
                   style={{ width: progress + "%" }}
              >
                {progress}%
              </div>
            </div>
          )} */}
          <div className="row padding-top">
            <div className="col">
              <h3>Upload new customer file</h3>
            </div>
          </div>
          <div className="row p-7 align-items-center">
            <div className="d-flex">
              <label className="btn btn-default upload-btn">
                <input type="file" onChange={selectFile} />
              </label>
            </div>

            <div className="flex-grow-1 d-flex align-items-center justify-content-start flex-row ml-10 mr-10">
              <label className="pr-3">Accounting software</label>
              <select
                className="custom-select"
                style={{ maxWidth: "300px" }}
                onChange={accountingSoftwareChanged}
              >
                {accountingSoftwares.map((accountingSoftware) => (
                  <option
                    key={accountingSoftware.type}
                    value={accountingSoftware.type}
                  >
                    {accountingSoftware.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-flex">
              <button
                className="btn btn-success float-right"
                disabled={!selectedFiles}
                onClick={upload}
              >
                Upload
                <span className="svg-icon-sm svg-icon-primary ml-3">
                  <SVG
                    width="15px"
                    height="15px"
                    src={toAbsoluteUrl("/media/svg/icons/Files/Upload.svg")}
                  ></SVG>
                </span>
              </button>
            </div>
          </div>

          <div role="alert">{message}</div>
        </div>

        <form className="padding-top-0">
          <div className="row">
            <div className="col">
              <h4>Fields Mapping</h4>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label>customer Code</label>
              <input
                type="text"
                className="form-control"
                value={fields.customerCode || ""}
                placeholder="customer Code"
                onChange={(e) =>
                  onMappingFormChange("customerCode", e.target.value)
                }
              />
            </div>
            <div className="col">
              <label>customer name</label>
              <input
                type="text"
                className="form-control"
                value={fields.customerName || ""}
                placeholder="customer name"
                onChange={(e) =>
                  onMappingFormChange("customerName", e.target.value)
                }
              />
            </div>
            <div className="col">
              <label>customer TaxId</label>
              <input
                type="text"
                className="form-control"
                value={fields.customerTaxId || ""}
                placeholder="customer TaxId"
                onChange={(e) =>
                  onMappingFormChange("customerTaxId", e.target.value)
                }
              />
            </div>
            <div className="col">
              <label>Grace (Days)</label>
              <input
                type="text"
                className="form-control"
                value={fields.customerGrace || ""}
                placeholder="Grace (Days)"
                onChange={(e) =>
                  onMappingFormChange("customerGrace", e.target.value)
                }
              />
            </div>
            <div className="col">
              <label>Column Separator</label>
              <input
                type="text"
                className="form-control"
                maxLength="1"
                value={fields.columnDelimiter}
                placeholder="Column Separator"
                onChange={(e) =>
                  onMappingFormChange("columnDelimiter", e.target.value)
                }
              />
            </div>
          </div>
          <div className="row mt-5">
            <div className="d-flex mr-5">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  className="form-control checkbox"
                  checked={fields.template || false}
                  onChange={(e) =>
                    onMappingFormChange("template", e.target.checked)
                  }
                />
                <span className="mr-3 ml-3" />
                save as a template
              </label>
            </div>
            {fields.template && (
              <div className="d-flex flex-row">
                <label className="checkbox checkbox-single">
                  template name
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={fields.templateName}
                  placeholder="template name"
                  onChange={(e) =>
                    onMappingFormChange("templateName", e.target.value)
                  }
                />
              </div>
            )}
          </div>
          {previewFile && (
            <div className="row mt-5">
              <h3>Preview file</h3>
            </div>
          )}
          {previewFile && (
            <div className="row mt-5">
              <div className="col">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Skip Rows"
                  onChange={(e) => refreshPreview(e.target.value)}
                />
              </div>
            </div>
          )}
          {previewFile && (
            <div className="row mt-5">
              {/* {previewFile && JSON.stringify(previewFile)} */}
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                remote
                keyField={"_id"}
                data={previewFile}
                columns={previewColumns}
              />
            </div>
          )}
        </form>
      </Card>
    );
  }

  return <div>Loading</div>;
}
